import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { helper } from 'src/environments/helper';
import { IEditLocatiePayload, IFormLocatie, ILocatie } from '../locatii.interface';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { LocatiiService } from '../locatii.service';
import { NotificationService } from 'src/app/services/notification.service';
import { finalize } from 'rxjs';

@Component({
    selector: 'app-edit-locatie',
    templateUrl: './edit-locatie.component.html',
    styleUrls: ['./edit-locatie.component.scss']
})
export class EditLocatieComponent {
    // general error
    errorTitle: string = helper.dialogConfig.headers.errorAtentie;
    errorIcon: string = helper.dialogConfig.icons.error;
    errorType: string = helper.dialogConfig.icons.error;
    helper = helper;

    isLoading = false;

    defaultParameter: { name: string; id: string } = {
        name: '--Alegeți--',
        id: '-1',
    };

    form: FormGroup = new FormGroup({
        name: new FormControl(this.data.name, [Validators.required]),
        id_extern: new FormControl(this.data.id_extern, [Validators.required]),
        address: new FormControl(this.data.address, [Validators.required]),
    });

    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: ILocatie,
        private dialogRef: MatDialogRef<EditLocatieComponent>,
        private locatiiService: LocatiiService,
        private notificationService: NotificationService,
    ) { }

    ngOnInit(): void { }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    submitForm() {
        this.isLoading = true;

        const { name, id_extern, address } = this.form.value as IFormLocatie;
        const payload: IEditLocatiePayload = {
            id_locatie: this.data.id_locatie,
            name,
            id_extern,
            address
        };

        this.locatiiService
            .updateLocatii(payload)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: (res) => {
                    this.dialogRef.close({ success: true });
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }
}
